/**
 * Awtomic Cart Rollup — CONSOLE BUILD (debug always on)
 * GENERATED FILE — do not edit. Regenerate with:
 *   node scripts/build-cart-extras-console.js
 * Sources: awtomic-theme-definitions.js + awtomic-cart-extras.js
 */
(function () {
  window.awtomicCartExtrasConfig = Object.assign(
    { debugMode: true },
    window.awtomicCartExtrasConfig,
  );
})();

/**
 * Awtomic Theme Definitions v1.0.0
 * Theme detection and selector configurations for cart rollup
 * Load BEFORE awtomic-cart-extras.js
 */
(function () {
  var has = function (s) {
    return !!document.querySelector(s);
  };

  // Shared selectors for table-based themes (Horizon/Tinker)
  var TABLE_SELECTORS = {
    cartItemRow: 'tr[data-key]',
    title: '.cart-items__title',
    image: '.cart-items__media-image',
    imageContainer: '.cart-items__media-container',
    imageLink: '.cart-items__link',
    variants: '.cart-items__variants',
    variantsWrapper: '.cart-items__variants-wrapper',
    unitPriceWrapper: '.cart-items__unit-price-wrapper',
    price: '.cart-items__price',
    compareAtPrice: '.compare-at-price',
    qtyInput: 'input[type="number"]',
    qtyButtons: '.quantity-minus, .quantity-plus',
    removeButton: '.cart-items__remove',
  };

  // Shared cart bubble configs
  var BUBBLE = {
    count: '.cart-bubble__text-count',
    visuallyHidden: '.cart-bubble__text .visually-hidden',
    container: '.cart-bubble',
  };

  var BUBBLE_WIDE = {
    count:
      '[data-testid="cart-bubble"], .cart-count, [id*="cart-count"], .cart-count-bubble span[aria-hidden="true"], .cart-bubble__text-count',
    visuallyHidden: '.visually-hidden',
    container: '.cart-bubble, .cart-count-bubble',
  };

  window.awtomicThemeDefinitions = {
    themes: {
      tinker: {
        name: 'Tinker',
        detect: function () {
          return (
            has('dialog.cart-drawer__dialog') &&
            has('cart-items-component[data-drawer]')
          );
        },
        selectors: TABLE_SELECTORS,
        drawer: {
          selectors: 'dialog.cart-drawer__dialog[open], dialog[open]',
          visibilityCheck: function (el) {
            return el && el.hasAttribute('open');
          },
          itemsComponent: 'cart-items-component[data-drawer]',
          closestContainer: 'dialog.cart-drawer__dialog',
        },
        cartBubble: BUBBLE,
      },

      horizon: {
        name: 'Horizon',
        detect: function () {
          return has('tr[data-key]') && has('.cart-items__title');
        },
        selectors: TABLE_SELECTORS,
        drawer: {
          selectors: 'cart-drawer, [data-drawer], .cart-drawer, #cart-drawer',
          visibilityCheck: function (el) {
            return (
              el &&
              (el.offsetParent ||
                el.hasAttribute('open') ||
                el.classList.contains('active') ||
                el.classList.contains('is-open'))
            );
          },
          itemsComponent: 'cart-items-component[data-drawer]',
          closestContainer: 'cart-drawer, .cart-drawer',
        },
        cartBubble: BUBBLE,
      },

      wonder: {
        name: 'Wonder',
        detect: function () {
          return has('.wt-cart__item') || has('.wt-cart__list');
        },
        selectors: {
          cartItemRow: 'li.wt-cart__item',
          title: '.wt-cart__item__name a',
          image: 'img.card__img',
          imageContainer: 'picture.wt-cart__item__thumb',
          imageLink: 'picture.wt-cart__item__thumb a.wt-cart__item__link',
          variants: '.options',
          variantsWrapper: '.wt-cart__item__data',
          unitPriceWrapper: '.wt-cart__item__price-wrapper',
          price: 'span.price.price--end',
          compareAtPrice: 's.cart-item__old-price',
          qtyInput: 'input.js-counter-quantity',
          qtyButtons: '.js-counter-button',
          removeButton: 'cart-remove-button a, a.wt-cart__item__remove',
        },
        drawer: {
          selectors:
            'cart-drawer-items.wt-cart__drawer__items, .wt-cart__drawer__body',
          visibilityCheck: function (el) {
            return el && el.offsetParent !== null;
          },
          itemsComponent: 'cart-drawer-items.wt-cart__drawer__items',
          closestContainer: '.wt-cart__drawer__body',
        },
        cartBubble: BUBBLE_WIDE,
      },

      dawn: {
        name: 'Dawn',
        detect: function () {
          var onCart = window.location.pathname.includes('/cart');
          return (
            has('quantity-popover') ||
            has('cart-remove-button') ||
            has('cart-items') ||
            (onCart &&
              (has('.cart-item__name') || has('.cart-item__image-container')))
          );
        },
        selectors: {
          cartItemRow: 'tr.cart-item, .cart-item',
          title: '.cart-item__name, a.cart-item__name',
          image: '.cart-item__image',
          imageContainer: '.cart-item__image-container',
          imageLink: 'a.cart-item__link',
          variants: '.product-option',
          variantsWrapper: '.cart-item__details',
          unitPriceWrapper: '.unit-price, .cart-item__totals',
          price: '.price--end, .product-option',
          compareAtPrice: '.price--end',
          qtyInput: 'input.quantity__input',
          qtyButtons: '.quantity__button',
          removeButton: 'cart-remove-button a, .cart-remove-button a',
        },
        drawer: null,
        cartBubble: {
          count: '.cart-count-bubble span[aria-hidden="true"]',
          visuallyHidden: '.cart-count-bubble .visually-hidden',
          container: '.cart-count-bubble',
        },
      },

      supply: {
        name: 'Supply',
        detect: function () {
          return (
            (has('#CartDrawer.drawer, .drawer#CartDrawer') ||
              has('[data-products]') ||
              window.location.pathname.includes('/cart')) &&
            has('.cart__items, .cart__item')
          );
        },
        selectors: {
          cartItemRow: '.cart__item[data-key]',
          title: '.cart__item-name',
          image: '.cart__image img',
          imageContainer: '.cart__image',
          imageLink: '.cart__image a',
          variants: '.cart__item--variants',
          variantsWrapper: '.cart__item-details',
          unitPriceWrapper: '.cart__item-price-col',
          price: '.cart__price',
          compareAtPrice: '.cart__price--strikethrough',
          qtyInput: 'input.js-qty__num',
          qtyButtons: '.js-qty__adjust',
          removeButton: '.cart__remove a',
        },
        drawer: {
          selectors: '#CartDrawer.drawer--is-open, .drawer.drawer--is-open',
          visibilityCheck: function (el) {
            return el && el.classList.contains('drawer--is-open');
          },
          itemsComponent: '.cart__items',
          closestContainer: '#CartDrawer, .drawer',
        },
        cartBubble: BUBBLE_WIDE,
      },

      rebuy: {
        name: 'Rebuy',
        detect: function () {
          return has('#rebuy-cart, .rebuy-cart');
        },
        selectors: {
          cartItemRow: 'li.rebuy-cart__flyout-item',
          title: '.rebuy-cart__flyout-item-product-title',
          image: '.rebuy-cart__flyout-item-media img',
          imageContainer: '.rebuy-cart__flyout-item-media',
          imageLink: '.rebuy-cart__flyout-item-media a',
          variants: '.rebuy-cart__flyout-item-discount-message',
          variantsWrapper: '.rebuy-cart__flyout-item-info',
          unitPriceWrapper: '.rebuy-cart__flyout-item-price',
          price: '.rebuy-money.sale span:not(.sr-only)',
          compareAtPrice: '.rebuy-money.compare-at span:not(.sr-only)',
          qtyInput: '.rebuy-cart__flyout-item-quantity-widget-label',
          qtyButtons: '.rebuy-cart__flyout-item-quantity-widget-button',
          removeButton: '.rebuy-cart__flyout-item-remove',
        },
        drawer: {
          selectors:
            '#rebuy-cart.is-visible, #rebuy-cart[aria-hidden="false"], .rebuy-cart.is-visible',
          visibilityCheck: function (el) {
            return (
              el &&
              (el.classList.contains('is-visible') ||
                el.getAttribute('aria-hidden') === 'false')
            );
          },
          itemsComponent: 'ul[data-smartcart-items]',
          closestContainer: '#rebuy-cart, .rebuy-cart',
        },
        cartBubble: BUBBLE_WIDE,
      },

      debut: {
        name: 'Debut',
        detect: function () {
          return (
            has('[data-section-type="cart-template"]') &&
            has('.list-view-item__title')
          );
        },
        selectors: {
          cartItemRow: 'tr.cart__row',
          title: '.list-view-item__title a',
          image: 'img.cart__image',
          imageContainer: '.cart__image-wrapper',
          imageLink: '.cart__image-wrapper a',
          variants: '.cart__meta-text',
          variantsWrapper: '.cart__meta',
          unitPriceWrapper: '.cart__price-wrapper',
          price:
            'td.text-right.small--hide > div:not(.cart-item__original-price):not(.cart-item__discount)',
          compareAtPrice: '.cart-item__original-price',
          qtyInput: 'input.cart__qty-input',
          qtyButtons: '.cart__qty-adjust',
          removeButton: 'a.cart__remove',
        },
        drawer: null,
        cartBubble: {
          count: '#CartCount > span:first-child',
          visuallyHidden: '#CartCount .icon__fallback-text',
          container: '#CartCount',
        },
      },

      bls: {
        name: 'BLS',
        detect: function () {
          return has('.bls-minicart-wrapper') && has('.bls-items');
        },
        selectors: {
          cartItemRow: 'div.cart-item',
          title: '.bls-minicart-product-name a',
          image: '.bls-minicart-product__image img',
          imageContainer: '.bls-minicart-product__image',
          imageLink: '.bls-minicart-product__image a',
          variants: '.bls-minicart-item-variant',
          variantsWrapper: '.bls-minicart-product-info',
          unitPriceWrapper: '.bls-minicart-item-prices',
          price: '.bls-minicart-item-price',
          compareAtPrice: '.bls-minicart-item-original-price',
          qtyInput: 'input.bls-quantity-input',
          qtyButtons: '.quantity__button',
          removeButton:
            'mini-cart-remove-button a, .bls-minicart-item-remove a',
        },
        drawer: {
          selectors: '.bls-minicart-wrapper',
          visibilityCheck: function (el) {
            return (
              el &&
              (el.offsetParent !== null ||
                el.classList.contains('active') ||
                el.classList.contains('is-open') ||
                el.classList.contains('open'))
            );
          },
          itemsComponent: '.bls-items',
          closestContainer: '.bls-minicart-wrapper',
        },
        cartBubble: BUBBLE_WIDE,
      },

      eVoiCustom: {
        name: 'eVoi Custom',
        detect: function () {
          return (
            has('input.quantity__input') &&
            (has('.cart__row.cart__item') ||
              has('#CartDrawer-CartItems') ||
              has('.drawer__contents-items') ||
              has('.drawer__inner[role="dialog"]'))
          );
        },
        selectors: {
          cartItemRow: '.cart__row.cart__item',
          title: '.cart-item__name.cart__product-title',
          image: 'img.cart__image',
          imageContainer: '.cart__image-box',
          imageLink: '.cart__image-wrapper a',
          variants: '.product-option',
          variantsWrapper: '.cart__product-information',
          unitPriceWrapper: '.unit-price, .cart__final-price',
          price: '.cart__final-price > div',
          compareAtPrice: 's.price--end',
          qtyInput: 'input.quantity__input',
          qtyButtons: '.quantity__button',
          removeButton: 'cart-remove-button a',
        },
        drawer: {
          selectors: '.drawer__inner[role="dialog"]',
          visibilityCheck: function (el) {
            return el && el.offsetParent !== null;
          },
          itemsComponent: '#CartDrawer-CartItems, .drawer__contents-items',
          closestContainer: '.drawer__inner',
        },
        cartBubble: BUBBLE_WIDE,
      },

      prestige: {
        name: 'Prestige',
        detect: function () {
          return (
            (window.location.pathname.includes('/cart') &&
              has('form.cart-page') &&
              has('table.order-summary') &&
              has('line-item .line-item-info a.h6') &&
              has('input.quantity-selector__input[data-line-key]')) ||
            (has('.cart-drawer__items line-item') &&
              has('.cart-drawer__items .line-item-info a.h6') &&
              has(
                '.cart-drawer__items input.quantity-selector__input[data-line-key]',
              ))
          );
        },
        selectors: {
          cartItemRow: ':scope > tr, :scope > line-item',
          title: '.line-item-info a.h6',
          image: 'img.line-item__media, line-item img',
          imageContainer: '.line-item__media',
          imageLink: '.line-item-info a.h6',
          variants:
            '.line-item-info ul.v-stack[role="list"], .line-item-info ul.text-subdued',
          variantsWrapper: '.line-item-info',
          unitPriceWrapper: 'td.text-end, .line-item-info .price-list',
          price: 'td.text-end, .price-list sale-price, sale-price',
          compareAtPrice: '.price-list compare-at-price, compare-at-price',
          qtyInput: 'input.quantity-selector__input[data-line-key]',
          qtyButtons: '.quantity-selector__button',
          removeButton:
            'a[href*="/cart/change"][href*="quantity=0"], a.link.text-xs[aria-label^="Remove"]',
        },
        drawer: {
          selectors:
            'cart-drawer[open], cart-drawer.is-open, .cart-drawer[open], .cart-drawer.is-open, dialog.cart-drawer__dialog[open], .cart-drawer__content',
          visibilityCheck: function (el) {
            return (
              !!el &&
              (el.hasAttribute('open') ||
                el.classList.contains('is-open') ||
                el.classList.contains('active') ||
                el.offsetParent !== null)
            );
          },
          itemsComponent: '.cart-drawer__items',
          closestContainer:
            'cart-drawer, .cart-drawer, dialog.cart-drawer__dialog, .cart-drawer__content',
        },
        cartBubble: BUBBLE_WIDE,
      },

      stretch: {
        name: 'Stretch',
        detect: function () {
          return (
            (has('line-item') || has('.line-item')) &&
            (has('table.order-summary') || has('cart-drawer'))
          );
        },
        selectors: {
          cartItemRow: 'tr, line-item',
          title: 'a.subheading[href*="/products/"]',
          image: 'img',
          imageContainer: '.line-item__media',
          imageLink: 'a.line-item__media',
          variants: 'ul[role="list"]',
          variantsWrapper: '.line-item__info',
          unitPriceWrapper: '.v-stack.justify-items-end',
          price: '.line-item__line-price',
          compareAtPrice: '.compare-at-price',
          qtyInput: 'input.quantity-selector__input',
          qtyButtons: '.quantity-selector__button',
          removeButton: '.line-item__remove-button',
        },
        drawer: {
          selectors: 'cart-drawer',
          visibilityCheck: function (el) {
            return (
              el &&
              (el.hasAttribute('open') ||
                (el.offsetParent !== null && el.style.display !== 'none'))
            );
          },
          itemsComponent: 'line-item',
          closestContainer: 'cart-drawer',
        },
        cartBubble: {
          count: '.h7',
          visuallyHidden: '.sr-only',
          container: 'cart-drawer',
        },
      },

      swirl: {
        name: 'Swirl',
        detect: function () {
          return (
            has('#update-cart[role="dialog"]') &&
            has('table.cart-items') &&
            has('tr.cart-item')
          );
        },
        selectors: {
          cartItemRow: 'tr.cart-item',
          title: 'a[href*="/products/"]',
          image: 'img[src*="cdn.shopify.com"]',
          imageContainer: '.relative.w-full',
          imageLink: 'a[href*="/products/"]',
          variants: 'dl, .product-option',
          variantsWrapper: 'dl, .product-info-column-1',
          unitPriceWrapper: '.price, .product-info-column-2',
          price: '.price-sale, .price',
          compareAtPrice: 's.cap',
          qtyInput: 'input.cart-qty, input[id^="cart-qty-"]',
          qtyButtons: 'button[class*="quantity"]',
          removeButton: 'button[class*="p-3"]',
        },
        drawer: {
          selectors: '#update-cart[role="dialog"]',
          visibilityCheck: function (el) {
            return (
              el &&
              (el.offsetParent !== null ||
                (el.style.display !== 'none' &&
                  el.getAttribute('aria-hidden') !== 'true'))
            );
          },
          itemsComponent: 'table.cart-items tbody',
          closestContainer: '#update-cart, #CartDrawer',
        },
        cartBubble: {
          count: '#mobile-cart-icon-bubble span, .x-cart-item-count',
          visuallyHidden: '.visually-hidden',
          container: '#mobile-cart-icon-bubble, .x-cart-item-count',
        },
      },

      upscale: {
        name: 'Upscale',
        detect: function () {
          // Upscale (by Loess) wraps its cart in <loess-*> custom elements and
          // renders rows as <tr class="cart-item">. The loess- tags are unique
          // to this theme family, so key detection off them.
          return (
            has('loess-cart-items') ||
            has('loess-cart-drawer-items') ||
            (has('loess-cart-remove-button') && has('tr.cart-item'))
          );
        },
        selectors: {
          cartItemRow: 'tr.cart-item',
          title: '.cart-item__details a[href*="/products/"]',
          image: '.cart-item__image',
          imageContainer: '.cart-item__image-container',
          imageLink: '.cart-item__link',
          variants: '.cart-item__details .product-option',
          variantsWrapper: '.cart-item__details',
          unitPriceWrapper: '.cart-item__price-wrapper, .cart-item__totals',
          price: '.cart-item__price-wrapper .price--end, .cart-item__final-price',
          compareAtPrice: '.cart-item__old-price',
          qtyInput: 'input.quantity__input',
          qtyButtons: '.quantity__button',
          removeButton: 'loess-cart-remove-button a',
        },
        drawer: {
          selectors:
            'loess-drawer#CartDrawer[open], #CartDrawer[open], #CartDrawer.drawer--is-open',
          visibilityCheck: function (el) {
            return el && (el.hasAttribute('open') || el.offsetParent !== null);
          },
          itemsComponent: 'loess-cart-drawer-items',
          closestContainer: 'loess-drawer#CartDrawer, #CartDrawer',
        },
        cartBubble: {
          count: '.header-cart-icon__count span[aria-hidden="true"]',
          visuallyHidden: '.header-cart-icon__count .sr-only',
          container: '.header-cart-icon__count',
        },
      },

      shapes: {
        name: 'Shapes',
        // Switch Themes "Shapes" (Alpine.js + Tailwind). Cart items are <li>
        // elements carrying data-line-item-key, rendered inside a
        // <data-island data-cart-items> component. The cart drawer teleports
        // its contents into [data-cart-drawer]. Rows have no distinctive
        // classes (utility classes only), so hooks key off data-* attributes.
        detect: function () {
                  return has('[data-cart-drawer]');
                },
          selectors: {
          cartItemRow: 'li[data-line-item-key]',
          // Two product links per row (image + title); the rollup prefers the
          // text-only one, so a broad anchor selector is safe.
          title: 'a[href*="/products/"]',
          image: 'img.media__styled-element',
          imageContainer: ':scope > div:first-child',
          imageLink: 'a[aria-hidden="true"][href*="/products/"]',
          variants: '[data-product-title] p.text-xs',
          variantsWrapper: '[data-product-title]',
          // Line total sits in its own right-aligned cell with a bare text
          // node (no inner span); price === unitPriceWrapper so the rollup
          // writes the total straight onto the element.
          unitPriceWrapper: '.break-words.text-right',
          price: '.break-words.text-right',
          compareAtPrice: '.compare-at-price',
          qtyInput: 'input[type="number"]',
          qtyButtons: '.input button',
          removeButton: 'a[href*="/cart/change"][href*="quantity=0"]',
        },
        drawer: {
          selectors: '[data-cart-drawer]',
          visibilityCheck: function (el) {
            return el && el.offsetParent !== null;
          },
          itemsComponent: '[data-cart-drawer] [data-cart-items]',
          closestContainer: '[data-cart-drawer]',
        },
        cartBubble: BUBBLE_WIDE,
      },

      generic: {
        name: 'Generic',
        detect: function () {
          return true;
        },
        selectors: {
          cartItemRow:
            'tr[data-key], li[data-key], div[data-key], tr.cart-item',
          title: 'a[href*="/products/"]',
          image: 'img[src*="cdn.shopify.com"]',
          imageContainer: '.image-container, .media-container',
          imageLink: 'a[href*="/products/"]',
          variants: 'dl, .variant',
          variantsWrapper: '.variants-wrapper, .product-options',
          unitPriceWrapper: '.price-wrapper, .unit-price, .price',
          price: '.price, .money, .cart-item-price, td.price',
          compareAtPrice: '.compare-at-price, .was-price, s.cap',
          qtyInput: 'input[type="number"]',
          qtyButtons:
            'button[name*="plus"], button[name*="minus"], .x-cart-item-quantity button',
          removeButton:
            'button[class*="remove"], a[class*="remove"], button[id*="remove"]',
        },
        drawer: {
          selectors:
            'cart-drawer, [data-drawer], .cart-drawer, #cart-drawer, #update-cart, dialog[open]',
          visibilityCheck: function (el) {
            return (
              el &&
              (el.offsetParent ||
                el.hasAttribute('open') ||
                el.classList.contains('active') ||
                el.classList.contains('is-open') ||
                (el.getAttribute('x-show') && el.style.display !== 'none'))
            );
          },
          itemsComponent: 'cart-items-component[data-drawer]',
          closestContainer: 'cart-drawer, .cart-drawer, dialog, #update-cart',
        },
        cartBubble: BUBBLE_WIDE,
      },
    },

    // Detection priority (specific first, generic last as fallback)
    detectionOrder: [
      'tinker',
      'horizon',
      'prestige',
      'stretch',
      'swirl',
      'wonder',
      'upscale',
      'eVoiCustom',
      'shapes',
      'dawn',
      'supply',
      'debut',
      'bls',
      'generic',
    ],
  };
})();

/**
 * Awtomic Cart Rollup v1.1.0
 * Consolidates dynamic bundle (BAB) child line items into a single bundle row
 * in the cart UI. Bundle membership is carried on each child item's custom
 * properties (_bundleUid, _bundleHandle, _bundleName, _variantId).
 *
 * Requires awtomic-theme-definitions.js (window.awtomicThemeDefinitions)
 * to be loaded first.
 *
 * The console build (awtomic-cart-extras-console.js) is generated from this
 * file — do not edit it by hand. Run: node scripts/build-cart-extras-console.js
 */
(function () {
  'use strict';

  const config = window.awtomicCartExtrasConfig || {};
  const DEBUG = !!config.debugMode;
  const debug = (...args) =>
    DEBUG && console.log('[Awtomic Cart Rollup]', ...args);

  const defs = window.awtomicThemeDefinitions || {
    themes: {},
    detectionOrder: [],
  };
  if (!window.awtomicThemeDefinitions) {
    console.warn(
      '[Awtomic Cart Rollup] Theme definitions not found. Load awtomic-theme-definitions.js first.',
    );
  }

  // ── Theme detection ────────────────────────────────────────────────────────

  const detectTheme = () => {
    // This asset is installed specifically in Switch Themes' Shapes theme.
    // Shapes renders portions of its cart asynchronously, so DOM-based
    // detection can otherwise identify the theme as Generic during startup.
    if (defs.themes.shapes) {
      return defs.themes.shapes;
    }

    if (config.theme && typeof config.theme === 'object') {
      debug('Using custom theme:', config.theme.name || 'Custom');
      return {
        name: config.theme.name || 'Custom',
        detect: config.theme.detect || (() => true),
        selectors: config.theme.selectors || {},
        drawer: config.theme.drawer ?? null,
        cartBubble: config.theme.cartBubble || null,
      };
    }
    for (const key of defs.detectionOrder) {
      const theme = defs.themes[key];
      if (theme?.detect?.()) {
        debug(`Detected theme: ${theme.name}`);
        return theme;
      }
    }
    return (
      defs.themes.generic || {
        name: 'Fallback',
        detect: () => true,
        selectors: {},
        drawer: null,
        cartBubble: null,
      }
    );
  };

  let THEME = detectTheme();

  // Normalized keys for THEME_CONFIG lookups. Prestige shares Stretch's DOM
  // handling (line-item elements, data-line-key inputs); its price-cell quirk
  // is handled by name in updateBundlePrices.
  const THEME_KEY_ALIASES = { 'evoi custom': 'evoi', prestige: 'stretch' };
  const norm = (name) => {
    const lower = (name || THEME.name).toLowerCase();
    return THEME_KEY_ALIASES[lower] || lower;
  };
  const isRebuy = (name) => norm(name) === 'rebuy';

  // Direct themes are modified in place. All others get their items container
  // cloned, processed, and swapped in (original kept hidden) so theme JS that
  // re-renders the original doesn't wipe our changes.
  const DIRECT_THEMES = new Set([
    'rebuy',
    'supply',
    'wonder',
    'bls',
    'evoi',
    'shapes',
  ]);
  const isDirectTheme = (name) => DIRECT_THEMES.has(norm(name));

  // ── Per-theme DOM strategy ─────────────────────────────────────────────────
  // Every theme-specific behavior lives here. To support a new theme, add a
  // map entry (missing keys fall back to `default`) plus, if needed, a key
  // extractor, and a theme entry in awtomic-theme-definitions.js.

  const THEME_CONFIG = {
    // Ancestor of cart item rows; used to check whether a bundle row for a
    // given bundle id has already been rendered.
    containerSelector: {
      rebuy: 'ul[data-smartcart-items]',
      supply: '.cart__items',
      wonder: 'ul.wt-cart__list',
      bls: '.bls-items',
      evoi: '.cart__row.cart__item',
      shapes: '[data-cart-items]',
      stretch:
        '.cart-drawer__items, .cart-drawer__content, .section-stack, tbody',
      swirl: 'table.cart-items tbody',
      default: 'tbody',
    },

    bundleItemSelector: {
      rebuy: (id) => `li[data-bundle-id="${id}"]`,
      shapes: (id) => `li[data-bundle-id="${id}"]`,
      supply: (id) => `.cart__item[data-bundle-id="${id}"]`,
      evoi: (id) => `.cart__row.cart__item[data-bundle-id="${id}"]`,
      stretch: (id) =>
        `line-item[data-bundle-id="${id}"], tr[data-bundle-id="${id}"]`,
      swirl: (id) => `tr.cart-item[data-bundle-id="${id}"]`,
      default: (id) => `[data-bundle-id="${id}"]`,
    },

    // Leftovers from a previous rollup pass, removed from the original
    // container before reprocessing (direct themes only; clone themes drop
    // the whole processed clone instead).
    cleanupSelector: {
      rebuy: 'li.awtomic-processed, li[data-awtomic-hidden]',
      bls: '.cart-item[data-awtomic-bundle], .cart-item[data-awtomic-hidden]',
      supply: '.cart__item.awtomic-processed, .cart__item[data-awtomic-hidden]',
      wonder: 'li[data-awtomic-bundle], li[data-awtomic-hidden]',
      shapes: 'li[data-awtomic-bundle], li[data-awtomic-hidden]',
      evoi: '.cart__row.cart__item[data-awtomic-bundle], .cart__row.cart__item[data-awtomic-hidden]',
      default: '[data-awtomic-bundle], [data-awtomic-hidden]',
    },

    // Locate { items, original } containers for a context: `original` holds
    // the cart item rows; `items` is its wrapper (clone themes append the
    // processed clone to it).
    findContainers: {
      rebuy: (ctx) => {
        const el = ctx.container.querySelector(
          'ul[data-smartcart-items], .rebuy-cart__flyout-items',
        );
        return { items: el, original: el };
      },
      bls: (ctx) => {
        const root = ctx.type === 'drawer' ? ctx.container : document;
        const el = root.querySelector('.bls-items');
        return { items: el, original: el };
      },
      wonder: (ctx) => {
        const root = ctx.type === 'drawer' ? ctx.container : document;
        const el = root.querySelector('ul.wt-cart__list');
        return { items: el, original: el };
      },
      shapes: (ctx) => {
        // Both page and drawer render a <data-island data-cart-items>; on a
        // cart page the drawer's copy is also in the DOM, so pick the island
        // that is NOT inside a drawer for the page context.
        let el;
        if (ctx.type === 'drawer') {
          el = ctx.container.querySelector('[data-cart-items]');
        } else {
          const islands = Array.from(
            document.querySelectorAll('[data-cart-items]'),
          );
          el =
            islands.find((n) => !n.closest('[data-cart-drawer]')) || islands[0];
        }
        return { items: el, original: el };
      },
      supply: (ctx) => {
        let el;
        if (ctx.type === 'drawer') {
          el = ctx.container.querySelector('.cart__items');
        } else {
          for (const candidate of document.querySelectorAll(
            '[data-products]',
          )) {
            if (candidate.querySelector('.cart__item')) {
              el = candidate;
              break;
            }
          }
          el = el || document.querySelector('[data-products], .cart__items');
        }
        return { items: el, original: el };
      },
      evoi: (ctx) => {
        const root = ctx.type === 'drawer' ? ctx.container : document;
        let el;
        if (ctx.type === 'drawer') {
          el = root.querySelector(
            '#CartDrawer-CartItems, .drawer__contents-items',
          );
        } else {
          el = root.querySelector(
            '.cart__items, .cart-items, form[action*="/cart"]',
          );
          if (!el) {
            const first = root.querySelector('.cart__row.cart__item');
            el =
              first?.closest(
                '.cart-form, .cart-wrapper, .cart-content, div[data-cart], form',
              ) || first?.parentElement;
          }
        }
        return { items: el, original: el };
      },
      stretch: (ctx) => {
        const root = ctx.type === 'drawer' ? ctx.container : document;
        if (ctx.type === 'drawer') {
          // Prestige wraps line items in .cart-drawer__items; Stretch needs a
          // scan for the v-stack that directly contains line-item elements.
          let parent = root.querySelector('.cart-drawer__items');
          if (!parent) {
            for (const candidate of root.querySelectorAll(
              '[class*="v-stack"]',
            )) {
              if (
                candidate.querySelector(
                  ':scope > line-item:not([data-bundle-id])',
                )
              ) {
                parent = candidate;
                break;
              }
            }
          }
          const original = parent || root;
          return { items: original.parentElement || root, original };
        }
        const table =
          root.querySelector('table.order-summary') ||
          root.querySelector('form[action*="/cart"] table');
        return { items: table, original: table?.querySelector('tbody') };
      },
      default: (ctx) => {
        const root = ctx.type === 'drawer' ? ctx.container : document;
        const table =
          root.querySelector('.cart-items__table, table.cart-items') ||
          root.querySelector('form[action*="/cart"] table');
        return { items: table, original: table?.querySelector('tbody') };
      },
    },
  };

  const getThemeConfig = (themeName) => {
    const key = norm(themeName);
    const pick = (map) => map[key] || map.default;
    return {
      containerSelector: pick(THEME_CONFIG.containerSelector),
      bundleItemSelector: pick(THEME_CONFIG.bundleItemSelector),
      cleanupSelector: pick(THEME_CONFIG.cleanupSelector),
      findContainers: pick(THEME_CONFIG.findContainers),
    };
  };

  // Ordered strategies for resolving a DOM row to a cart line item key.
  // `themes` / `notThemes` gate a strategy to normalized theme keys.
  const KEY_EXTRACTORS = [
    { extract: (row) => row.dataset.key },
    {
      // Shapes: the <li> row carries the exact "VARIANT:HASH" cart key.
      themes: ['shapes'],
      extract: (row) => row.dataset.lineItemKey,
    },
    {
      themes: ['stretch'],
      extract: (row) =>
        row.querySelector('input[data-line-key]')?.dataset.lineKey,
    },
    { extract: (row) => row.querySelector('input[data-key]')?.dataset.key },
    {
      // Rebuy renders no keys; match via property/product classes on the row.
      // Sibling rows of one bundle share the same classes, so exclude items
      // already matched to earlier rows.
      themes: ['rebuy'],
      extract: (row, cartData, matchedIndices) => {
        const classes = Array.from(row.classList);
        const available = (fn) =>
          cartData?.items?.find((it, i) => !matchedIndices.has(i) && fn(it));
        const uidClass = classes.find((c) =>
          c.startsWith('property-_bundleuid:'),
        );
        if (uidClass) {
          const uid = uidClass.split(':')[1];
          const item = available(
            (it) => it.properties?._bundleUid?.replace(/-/g, '') === uid,
          );
          if (item) {
            return item.key;
          }
        }
        const productClass = classes.find(
          (c) => c.startsWith('product-') && !c.startsWith('product-id-'),
        );
        if (productClass) {
          const handle = productClass.replace('product-', '');
          return available((it) => it.handle === handle)?.key;
        }
        return null;
      },
    },
    {
      // Debut: qty input id is "updates_{VARIANT}:{HASH}".
      themes: ['debut'],
      extract: (row) => {
        const id = row.querySelector('input.cart__qty-input')?.id;
        return id?.startsWith('updates_') ? id.slice('updates_'.length) : null;
      },
    },
    {
      // Swirl and generic drawers: qty input id is "cart-qty-{VARIANT}:{HASH}".
      notThemes: ['rebuy', 'debut'],
      extract: (row) => {
        const id = row.querySelector(
          'input.cart-qty, input[id^="cart-qty-"]',
        )?.id;
        if (!id?.startsWith('cart-qty-')) {
          return null;
        }
        const key = id.slice('cart-qty-'.length);
        return key.includes(':') ? key : null;
      },
    },
    {
      // BLS: row id is "bls-minicart-product-{VARIANT}:{HASH}".
      themes: ['bls'],
      extract: (row) =>
        row.id?.startsWith('bls-minicart-product-')
          ? row.id.slice('bls-minicart-product-'.length)
          : null,
    },
    {
      // Dawn/Wonder: row id "CartItem-N"/"CartDrawer-Item-N" is a 1-based index.
      notThemes: ['bls'],
      extract: (row, cartData) => {
        const match = row.id?.match(/Cart(?:Drawer-)?Item-(\d+)/);
        return match
          ? cartData?.items?.[parseInt(match[1], 10) - 1]?.key
          : null;
      },
    },
  ];

  // ── Styles ─────────────────────────────────────────────────────────────────

  const injectCSS = () => {
    if (!document.getElementById('awtomic-cart-antiflicker')) {
      const antiFlicker = document.createElement('style');
      antiFlicker.id = 'awtomic-cart-antiflicker';
      antiFlicker.textContent = `
        body:not(.awtomic-cart-processed) .cart__items:not(.awtomic-ready),
        body:not(.awtomic-cart-processed) [data-products]:not(.awtomic-ready),
        body:not(.awtomic-cart-processed) .rebuy-cart__flyout-items:not(.awtomic-ready),
        body:not(.awtomic-cart-processed) .cart-items__table:not(.awtomic-ready),
        body:not(.awtomic-cart-processed) cart-items-component[data-drawer]:not(.awtomic-ready),
        body:not(.awtomic-cart-processed) .wt-cart__list:not(.awtomic-ready),
        body:not(.awtomic-cart-processed) .bls-items:not(.awtomic-ready),
        body:not(.awtomic-cart-processed) table.cart-items:not(.awtomic-ready) tbody,
        body:not(.awtomic-cart-processed) [data-section-type="cart-template"] table tbody:not(.awtomic-ready) {
          visibility: hidden !important;
          opacity: 0 !important;
        }
      `;
      document.head.appendChild(antiFlicker);
    }

    if (!document.getElementById('awtomic-cart-rollup-styles')) {
      const permanent = document.createElement('style');
      permanent.id = 'awtomic-cart-rollup-styles';
      permanent.textContent = `
        tbody.awtomic-original { display: none !important; }
        tbody.awtomic-processed { display: table-row-group !important; }
        .rebuy-cart__flyout-item-subscription { display: none !important; }
        line-item[data-awtomic-hidden] { display: none !important; }
        tr[data-awtomic-hidden] { display: none !important; }
        [data-awtomic-bundle] .cart-item__quantity button:last-of-type { visibility: hidden !important; pointer-events: none !important; }
        [data-awtomic-bundle] button[class*="remove"] { display: none !important; }
      `;
      document.head.appendChild(permanent);
    }
  };

  const removeAntiFlicker = () => {
    document.body.classList.add('awtomic-cart-processed');
    setTimeout(
      () => document.getElementById('awtomic-cart-antiflicker')?.remove(),
      1000,
    );
  };

  injectCSS();

  // ── State ──────────────────────────────────────────────────────────────────

  let isProcessing = false;
  let lastProcessedTime = 0;
  const observers = { drawer: null, rebuy: null };
  const productCache = new Map();
  const lastCartData = { page: null, drawer: null, rebuy: null };
  const rollupAlreadyDone = { page: false, drawer: false, rebuy: false };

  // ── Cart data ──────────────────────────────────────────────────────────────

  const fetchCartData = async () => {
    try {
      const response = await fetch('/cart.js');
      return response.ok ? await response.json() : null;
    } catch (_err) {
      return null;
    }
  };

  // 404 is expected when _bundleHandle isn't a real Shopify product.
  const fetchBundleProductData = async (bundleHandle, variantId) => {
    const cacheKey = `${bundleHandle}:${variantId}`;
    if (productCache.has(cacheKey)) {
      return productCache.get(cacheKey);
    }
    try {
      const response = await fetch(`/products/${bundleHandle}.js`);
      if (!response.ok) {
        return null;
      }
      const product = await response.json();
      const result = {
        product,
        variant: product.variants.find(
          (v) => v.id.toString() === String(variantId).split('/').pop(),
        ),
      };
      productCache.set(cacheKey, result);
      return result;
    } catch (_err) {
      return null;
    }
  };

  const groupBundleItems = (cartData) => {
    const groups = {};
    for (const item of cartData?.items || []) {
      const bundleId = item.properties?._bundleUid;
      if (bundleId) {
        if (!groups[bundleId]) {
          groups[bundleId] = { items: [], properties: item.properties };
        }
        groups[bundleId].items.push(item);
      }
    }
    return groups;
  };

  // The $0 bundle container product carries no _bundleUid; it's identified by
  // the bundle's _variantId (numeric or GID form) plus a zero price.
  const getContainerVariantId = (group) => {
    const raw = group.properties._variantId;
    return raw ? String(raw).split('ProductVariant/').pop() : null;
  };

  const isBundleContainerItem = (item, bundleItemKeys, containerVariantIds) =>
    !bundleItemKeys.has(item.key) &&
    item.final_line_price === 0 &&
    containerVariantIds.has(item.key.split(':')[0]);

  // The $0 container line item carries the real bundle product image; locate it
  // for a group by its _variantId so the rolled-up row can use it.
  const findContainerItem = (cartData, group) => {
    const variantId = getContainerVariantId(group);
    if (!variantId) {
      return null;
    }
    return (
      cartData?.items?.find(
        (item) =>
          item.final_line_price === 0 &&
          item.key.split(':')[0] === variantId,
      ) || null
    );
  };

  // ── Context discovery ──────────────────────────────────────────────────────

  const getCartContexts = () => {
    const contexts = [];

    // Rebuy Smart Cart is independent of the detected theme.
    const rebuyCart = document.querySelector('#rebuy-cart, .rebuy-cart');
    if (rebuyCart) {
      contexts.push({ type: 'rebuy', container: rebuyCart, theme: 'Rebuy' });
      debug('Found Rebuy cart');
    }

    const drawerConfig = THEME.drawer;
    if (drawerConfig && !isRebuy(THEME.name)) {
      const drawer = document.querySelector(drawerConfig.selectors);
      if (drawer && drawerConfig.visibilityCheck(drawer)) {
        contexts.push({ type: 'drawer', container: drawer, theme: THEME.name });
        debug(`Found ${THEME.name} drawer cart`);
      } else {
        const items = document.querySelector(drawerConfig.itemsComponent);
        if (items?.offsetParent || items?.querySelector('line-item')) {
          contexts.push({
            type: 'drawer',
            container: items.closest(drawerConfig.closestContainer) || items,
            theme: THEME.name,
          });
          debug(`Found ${THEME.name} drawer cart (via items component)`);
        }
      }
    }

    const isCartPage =
      window.location.pathname.includes('/cart') ||
      document.querySelector(
        '.cart-page, [data-cart-page], main.cart, cart-items',
      );
    if (isCartPage && !isRebuy(THEME.name)) {
      contexts.push({ type: 'page', container: document, theme: THEME.name });
      debug('Found cart page');
    }

    return contexts;
  };

  // ── DOM ↔ cart matching ────────────────────────────────────────────────────

  const findAndMatchCartItems = (cartData, container, selectors, themeName) => {
    const themeKey = norm(themeName);
    const matchedIndices = new Set();

    let rows = Array.from(container.querySelectorAll(selectors.cartItemRow));
    if (rows.length === 0 && container.tagName === 'TBODY') {
      rows = Array.from(container.querySelectorAll(':scope > tr'));
    }

    const matches = [];
    for (const row of rows) {
      for (const extractor of KEY_EXTRACTORS) {
        if (extractor.themes && !extractor.themes.includes(themeKey)) {
          continue;
        }
        if (extractor.notThemes && extractor.notThemes.includes(themeKey)) {
          continue;
        }
        const key = extractor.extract(row, cartData, matchedIndices);
        if (!key) {
          continue;
        }
        const index = cartData.items.findIndex(
          (item, i) => !matchedIndices.has(i) && item.key === key,
        );
        if (index === -1) {
          continue;
        }
        matchedIndices.add(index);
        matches.push({ row, cartItem: cartData.items[index] });
        break;
      }
    }
    return matches;
  };

  // ── DOM helpers ────────────────────────────────────────────────────────────

  const formatPrice = (cents) => {
    if (typeof window.Shopify?.formatMoney === 'function') {
      try {
        return window.Shopify.formatMoney(cents);
      } catch (_err) {
        // fall through to default formatting
      }
    }
    return `$${(cents / 100).toFixed(2)}`;
  };

  const onDocReady = (fn) =>
    document.readyState === 'loading'
      ? document.addEventListener('DOMContentLoaded', fn)
      : fn();

  const setStyles = (element, styles) =>
    element && Object.assign(element.style, styles);

  // ── Bundle row rendering ───────────────────────────────────────────────────

  const createBundleSubitem = (item) => {
    const subitem = document.createElement('div');
    subitem.className = 'bundle-subitem';
    subitem.style.cssText =
      'display: flex; align-items: flex-start; margin-bottom: 8px;';

    if (item.image) {
      const imgContainer = document.createElement('div');
      imgContainer.style.cssText =
        'margin-right: 10px; display: flex; margin-top: 15px; overflow: hidden; max-width: 40px; width: 40px; min-width: 40px; justify-content: center;';
      const img = Object.assign(document.createElement('img'), {
        src: item.image,
        alt: item.product_title,
      });
      img.style.cssText = 'width: auto; height: 45px; object-fit: contain;';
      imgContainer.appendChild(img);
      subitem.appendChild(imgContainer);
    }

    const details = document.createElement('div');
    details.className = 'bundle-subitem-details';
    details.style.cssText = 'flex: 1; font-size: 0.875em; line-height: 1.4;';

    const title = document.createElement('div');
    title.style.cssText = 'font-weight: 500;';
    title.textContent = item.product_title;
    details.appendChild(title);

    if (item.variant_title && item.variant_title !== 'Default Title') {
      const variant = document.createElement('div');
      variant.style.cssText = 'color: #6b7280; font-size: 0.9em;';
      variant.textContent = item.variant_title;
      details.appendChild(variant);
    }

    const qty = document.createElement('div');
    qty.style.cssText = 'color: #6b7280; font-size: 0.9em; margin-top: 2px;';
    qty.textContent = `Qty: ${item.quantity}`;
    details.appendChild(qty);

    subitem.appendChild(details);
    return subitem;
  };

  const buildSubitemsContainer = (items) => {
    const container = Object.assign(document.createElement('div'), {
      className: 'bundle-subitems',
    });
    setStyles(container, { marginTop: '15px' });
    items.forEach((item) => container.appendChild(createBundleSubitem(item)));
    return container;
  };

  const updateBundlePrices = (bundleRow, items, selectors, themeName) => {
    const totalPrice = items.reduce((sum, i) => sum + i.final_line_price, 0);
    const totalOriginalPrice = items.reduce(
      (sum, i) => sum + i.original_line_price,
      0,
    );

    let priceEl = bundleRow.querySelector(selectors.price);
    if (!priceEl) {
      priceEl = bundleRow.querySelector(
        'td.total strong, td.total, [class*="total"] strong, [class*="price"] strong, .cart-item-price, .price span:not(.compare-at-price):not(.price-sale)',
      );
    }

    // Generic price nodes (e.g. Swirl) — update the sale span when present,
    // or the element itself when it has no inner price markup.
    bundleRow.querySelectorAll('.cart-item-price, .price').forEach((el) => {
      if (el.closest('.compare-at-price, s.cap')) {
        return;
      }
      const saleSpan = el.querySelector(
        '.price-sale, span.price-sale, span:not(.compare-at-price):not(s)',
      );
      if (saleSpan) {
        saleSpan.textContent = formatPrice(totalPrice);
      } else if (!el.querySelector('span, s')) {
        el.textContent = formatPrice(totalPrice);
      }
    });

    const unitPriceWrapper = bundleRow.querySelector(
      selectors.unitPriceWrapper,
    );
    if (unitPriceWrapper) {
      if (priceEl && unitPriceWrapper.contains(priceEl)) {
        // Nested price (e.g. Rebuy): update it directly to avoid clobbering
        // surrounding markup (sr-only labels, wrapper spans).
        priceEl.textContent = formatPrice(totalPrice);
      } else {
        const span = unitPriceWrapper.querySelector(
          'span:not(.visually-hidden):not(.compare-at-price):not(s)',
        );
        if (span) {
          span.textContent = formatPrice(totalPrice);
        }
      }

      const compareAtEl = unitPriceWrapper.querySelector(
        selectors.compareAtPrice,
      );
      if (compareAtEl) {
        // For Rebuy the selector targets an inner span; toggle the wrapper.
        const compareAtContainer =
          compareAtEl.parentElement !== unitPriceWrapper
            ? compareAtEl.parentElement
            : compareAtEl;
        if (totalOriginalPrice > totalPrice) {
          compareAtEl.textContent = formatPrice(totalOriginalPrice);
          compareAtContainer.style.display = '';
        } else {
          compareAtContainer.style.display = 'none';
        }
      }
    }

    if (priceEl && !unitPriceWrapper?.contains(priceEl)) {
      priceEl.textContent = formatPrice(totalPrice);
    }

    // Compare-at in the same cell as the price (e.g. Debut's total column).
    const priceCell =
      priceEl && (priceEl.closest('td') || priceEl.parentElement);
    const cellCompareEl = priceCell?.querySelector(selectors.compareAtPrice);
    if (cellCompareEl) {
      if (totalOriginalPrice > totalPrice) {
        const sTag = cellCompareEl.querySelector('s');
        (sTag || cellCompareEl).textContent = formatPrice(totalOriginalPrice);
        cellCompareEl.style.display = '';
      } else {
        cellCompareEl.style.display = 'none';
      }
    }

    // Prestige has a separate rightmost total cell to keep in sync.
    if (themeName === 'Prestige') {
      const totalCell = bundleRow.querySelector('td.text-end');
      if (totalCell) {
        totalCell.textContent = formatPrice(totalPrice);
      }
    }
  };

  const disableBundleQuantityControls = (bundleRow, themeName, selectors) => {
    const qtyElements = bundleRow.querySelectorAll(selectors.qtyInput);

    if (isRebuy(themeName)) {
      // Rebuy's "input" selector is a label; set its text node to 1.
      qtyElements.forEach((el) => {
        const textNode = Array.from(el.childNodes).find(
          (node) => node.nodeType === Node.TEXT_NODE,
        );
        if (textNode) {
          textNode.textContent = ' 1 ';
        }
      });
    } else {
      qtyElements.forEach((el) =>
        Object.assign(el, { value: '1', readOnly: true, disabled: true }),
      );
    }

    const hide = (btn) =>
      setStyles(btn, {
        visibility: 'hidden',
        opacity: '0',
        pointerEvents: 'none',
      });
    bundleRow.querySelectorAll(selectors.qtyButtons).forEach(hide);
    bundleRow
      .querySelectorAll('.x-cart-item-quantity button, .quantity button')
      .forEach(hide);
  };

  const setupRemoveButton = (bundleRow, bundleId, selectors, themeName) => {
    let removeButtons = [];

    if (norm(themeName) === 'evoi') {
      // eVoi: repurpose the minus button as the remove trigger.
      const minusBtn = bundleRow.querySelector('button.qtyminus');
      if (minusBtn) {
        removeButtons = [minusBtn];
        setStyles(minusBtn, {
          visibility: 'visible',
          opacity: '1',
          pointerEvents: 'auto',
        });
      }
    } else {
      removeButtons = Array.from(
        bundleRow.querySelectorAll(selectors.removeButton),
      );
      if (removeButtons.length === 0) {
        removeButtons = Array.from(bundleRow.querySelectorAll('button')).filter(
          (btn) => {
            const text = btn.textContent.trim();
            return (
              text === '×' ||
              text === '✕' ||
              text === 'x' ||
              text.toLowerCase().includes('remove')
            );
          },
        );
      }
    }
    if (removeButtons.length === 0) {
      return;
    }

    // Neutralize cart-remove-button custom elements: replace with plain spans
    // so connectedCallback won't register competing click handlers when the
    // bundle row is inserted into the DOM.
    bundleRow
      .querySelectorAll('cart-remove-button, mini-cart-remove-button')
      .forEach((crb) => {
        const plain = document.createElement('span');
        plain.className = crb.className;
        if (crb.id) {
          plain.id = crb.id;
        }
        while (crb.firstChild) {
          plain.appendChild(crb.firstChild);
        }
        crb.parentNode.replaceChild(plain, crb);
      });

    const handleRemoveClick = async (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      setStyles(bundleRow, { opacity: '0.6', pointerEvents: 'none' });

      try {
        const cart = await fetchCartData();
        const updates = {};
        for (const item of cart?.items || []) {
          if (item.properties?._bundleUid === bundleId) {
            updates[item.key] = 0;
          }
        }

        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates }),
        });

        if (response.ok) {
          bundleRow.remove();
          const updatedCart = await fetchCartData();
          if (updatedCart) {
            updateCartBubble(updatedCart);
            lastCartData.page = updatedCart;
            lastCartData.drawer = updatedCart;
            lastCartData.rebuy = updatedCart;
          }
        } else {
          setStyles(bundleRow, { opacity: '', pointerEvents: '' });
        }
      } catch (_err) {
        setStyles(bundleRow, { opacity: '', pointerEvents: '' });
      }
    };

    removeButtons.forEach((removeButton) => {
      if (removeButton.classList.contains('qtyminus')) {
        const trashBtn = bundleRow.querySelector('.quantity__button.qtyremove');
        if (trashBtn) {
          setStyles(trashBtn, { display: 'none' });
        }
        removeButton.addEventListener('click', handleRemoveClick);
        return;
      }
      // Wrap the button and listen on the wrapper so theme handlers bound to
      // the button itself never fire (pointer events are disabled on it).
      const wrapper = document.createElement('div');
      setStyles(
        wrapper,
        isRebuy(themeName)
          ? {
              display: 'inline-block',
              cursor: 'pointer',
              position: 'absolute',
              top: '0',
              right: '0',
              width: '20px',
              height: '20px',
            }
          : { display: 'inline-block', cursor: 'pointer' },
      );
      removeButton.parentNode.insertBefore(wrapper, removeButton);
      wrapper.appendChild(removeButton);
      removeButton.href = '#';
      setStyles(removeButton, { pointerEvents: 'none' });
      wrapper.addEventListener('click', handleRemoveClick);
    });
  };

  const updateBundleImage = (bundleRow, product, selectors, fallbackImage) => {
    const imageContainer = bundleRow.querySelector(selectors.imageContainer);
    if (!imageContainer) {
      return;
    }
    // Prefer the fetched bundle product image, then fall back to the $0
    // container line item's image. Without the fallback the cloned first-item
    // image would remain whenever the _bundleHandle fetch 404s.
    const productImage =
      product?.featured_image || product?.images?.[0]?.src || fallbackImage;
    if (productImage) {
      const img = imageContainer.querySelector('img');
      if (img) {
        img.src = productImage;
        img.alt = product?.title || '';
        // Clear the cloned item's responsive attrs; otherwise the browser
        // resolves the old srcset image instead of our new src.
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
      }
      const link = imageContainer.querySelector('a');
      if (link && product?.handle) {
        link.href = `/products/${product.handle}`;
      }
    } else {
      imageContainer.style.visibility = 'hidden';
    }
  };

  const addVariantTitle = (variantsWrapper, variant) => {
    if (!variantsWrapper || !variant) {
      return;
    }
    if (variant.title && variant.title !== 'Default Title') {
      const variantDiv = Object.assign(document.createElement('div'), {
        className: 'cart-items__variant',
        textContent: variant.title,
      });
      setStyles(variantDiv, { margin: '5px 0', display: 'block' });
      variantsWrapper.insertBefore(variantDiv, variantsWrapper.firstChild);
    }
  };

  const updateCartBubble = (cartData) => {
    const bundleGroups = groupBundleItems(cartData);
    const bundleItemKeys = new Set(
      Object.values(bundleGroups).flatMap((g) => g.items.map((i) => i.key)),
    );
    const bundleCount = Object.keys(bundleGroups).length;
    // Hidden $0 container products must not count as standalone items.
    const containerVariantIds = new Set(
      Object.values(bundleGroups).map(getContainerVariantId).filter(Boolean),
    );
    const standaloneCount = cartData.items
      .filter(
        (i) =>
          !bundleItemKeys.has(i.key) &&
          !isBundleContainerItem(i, bundleItemKeys, containerVariantIds),
      )
      .reduce((sum, item) => sum + (item.quantity || 0), 0);
    const totalCount = bundleCount + standaloneCount;

    debug(
      `Cart bubble: ${totalCount} (${bundleCount} bundles + ${standaloneCount} standalone)`,
    );

    const bubble = THEME.cartBubble;
    if (!bubble) {
      return;
    }
    document.querySelectorAll(bubble.count).forEach((el) => {
      el.textContent = totalCount;
    });
    document.querySelectorAll(bubble.container).forEach((container) => {
      container.querySelectorAll(bubble.visuallyHidden).forEach((el) => {
        el.textContent =
          THEME.name === 'Dawn'
            ? `${totalCount} items`
            : `Total items in cart: ${totalCount}`;
      });
      container.classList.add('awtomic-ready');
    });
  };

  const formatBundleName = (name) =>
    name
      .split('-')
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(' ');

  const createBundleRows = async (
    bundleGroups,
    matches,
    themeName,
    selectors,
    cartData,
  ) => {
    const themeCfg = getThemeConfig(themeName);

    for (const [bundleId, group] of Object.entries(bundleGroups)) {
      // Skip if this bundle's row already exists in the container.
      if (
        matches[0]?.row
          .closest(themeCfg.containerSelector)
          ?.querySelector(themeCfg.bundleItemSelector(bundleId))
      ) {
        continue;
      }

      const firstMatch = matches.find(
        (m) => m.cartItem.key === group.items[0].key,
      );
      if (!firstMatch) {
        debug(`Bundle ${bundleId}: first item not matched in DOM, skipping`);
        continue;
      }

      const bundleProductData =
        group.properties._bundleHandle && group.properties._variantId
          ? await fetchBundleProductData(
              group.properties._bundleHandle,
              group.properties._variantId,
            )
          : null;
      const product = bundleProductData?.product || null;
      const variant = bundleProductData?.variant || null;

      // Rebuy's cart is Vue-managed: clone insertion triggers reconciliation
      // that wipes our content, so modify the first item's row in place.
      const bundleRow = isRebuy(themeName)
        ? firstMatch.row
        : firstMatch.row.cloneNode(true);
      Object.assign(bundleRow.dataset, {
        bundleId,
        bundleHandle: group.properties._bundleHandle,
        awtomicBundle: 'true',
        key: `bundle-${bundleId}`,
      });

      // Clear the source item's variant/property content.
      if (norm(themeName) !== 'evoi') {
        bundleRow.querySelector(selectors.variants)?.remove();
      }
      bundleRow
        .querySelectorAll('ul.list-unstyled')
        .forEach((el) => el.remove());
      bundleRow
        .querySelectorAll('ul[role="list"]:not(.unstyled-list)')
        .forEach((el) => el.remove());
      if (isRebuy(themeName)) {
        const props = bundleRow.querySelector(
          '.rebuy-cart__flyout-item-properties',
        );
        if (props) {
          props.style.display = 'none';
        }
      }

      const bundleTitle =
        product?.title ||
        group.properties.bundle ||
        (group.properties._bundleName
          ? formatBundleName(group.properties._bundleName)
          : 'Bundle');
      const bundleUrl = product
        ? `/products/${product.handle}${variant ? `?variant=${variant.id}` : ''}`
        : group.properties._bundleHandle
          ? `/products/${group.properties._bundleHandle}`
          : null;

      // Prefer a text-only title link over one wrapping an image.
      const titleLinks = bundleRow.querySelectorAll(selectors.title);
      const titleEl =
        Array.from(titleLinks).find((link) => !link.querySelector('img')) ||
        titleLinks[0] ||
        null;
      if (titleEl) {
        titleEl.textContent = bundleTitle;
        if (bundleUrl) {
          titleEl.href = bundleUrl;
        }
        // Drop duplicate text product links; keep image links for layout but
        // blank their images.
        const titleCell =
          titleEl.closest('td, div, li') || titleEl.parentElement;
        titleCell?.querySelectorAll('a[href*="/products/"]').forEach((link) => {
          if (link === titleEl) {
            return;
          }
          if (link.querySelector('img')) {
            link.querySelectorAll('img').forEach((img) => {
              img.style.visibility = 'hidden';
            });
          } else {
            link.remove();
          }
        });
      }

      const containerItem = findContainerItem(cartData, group);
      updateBundleImage(bundleRow, product, selectors, containerItem?.image);

      // Subitems: list each child product inside the bundle row.
      const variantsWrapper = bundleRow.querySelector(
        selectors.variantsWrapper,
      );
      if (norm(themeName) === 'evoi') {
        // eVoi: insert before the quantity/remove section.
        const productInfo = bundleRow.querySelector(
          '.cart__product-information',
        );
        const bottomSection = productInfo?.querySelector(
          '.cart__information-td.cart__information--bottom',
        );
        if (productInfo && bottomSection) {
          productInfo.insertBefore(
            buildSubitemsContainer(group.items),
            bottomSection,
          );
        }
      } else {
        let subitemsTarget = variantsWrapper;
        if (!subitemsTarget && titleEl) {
          const titleWrapper = document.createElement('div');
          titleWrapper.style.cssText =
            'display: inline-block; vertical-align: top;';
          titleEl.parentNode.insertBefore(titleWrapper, titleEl);
          titleWrapper.appendChild(titleEl);
          subitemsTarget = titleWrapper;
        }
        if (variantsWrapper) {
          addVariantTitle(variantsWrapper, variant);
        }
        if (subitemsTarget) {
          subitemsTarget.appendChild(buildSubitemsContainer(group.items));
        }
      }

      updateBundlePrices(bundleRow, group.items, selectors, themeName);
      disableBundleQuantityControls(bundleRow, themeName, selectors);
      setupRemoveButton(bundleRow, bundleId, selectors, themeName);

      if (!isRebuy(themeName)) {
        firstMatch.row.parentNode.insertBefore(bundleRow, firstMatch.row);
      }

      // Hide the bundle's child rows and the $0 bundle container product.
      const bundleItemKeys = new Set(group.items.map((item) => item.key));
      const containerVariantIds = new Set(
        [getContainerVariantId(group)].filter(Boolean),
      );

      matches.forEach((match) => {
        const isBundleItem = bundleItemKeys.has(match.cartItem.key);
        const isBundleContainer = isBundleContainerItem(
          match.cartItem,
          bundleItemKeys,
          containerVariantIds,
        );

        if (!isBundleItem && !isBundleContainer) {
          return;
        }
        // Rebuy: the first item's row IS the bundle row — keep it visible.
        if (isRebuy(themeName) && match.row === firstMatch.row) {
          return;
        }
        match.row.style.setProperty('display', 'none', 'important');
        match.row.dataset.awtomicHidden = 'true';
        const content = match.row.querySelector(
          '.line-item__info-with-line-price',
        );
        if (content) {
          content.style.setProperty('display', 'none', 'important');
        }
      });
    }
  };

  // ── Processing pipeline ────────────────────────────────────────────────────

  const cartDataUnchanged = (previous, current) =>
    previous &&
    previous.items.length === current.items.length &&
    previous.items.every((item, i) => {
      const next = current.items[i];
      return next && item.key === next.key && item.quantity === next.quantity;
    });

  const processCartContext = async (context, cartData) => {
    if (cartDataUnchanged(lastCartData[context.type], cartData)) {
      debug(`Cart data unchanged for ${context.type}, skipping`);
      return;
    }
    lastCartData[context.type] = cartData;
    isProcessing = true;
    lastProcessedTime = Date.now();

    try {
      const themeName = context.theme;
      const selectors = isRebuy(themeName)
        ? defs.themes.rebuy?.selectors || THEME.selectors
        : THEME.selectors;
      const themeCfg = getThemeConfig(themeName);

      const { items: itemsContainer, original: originalContainer } =
        themeCfg.findContainers(context);
      if (!originalContainer) {
        debug(`No items container found for ${themeName} ${context.type} cart`);
        return;
      }

      const markReady = () => {
        itemsContainer?.classList.add('awtomic-ready');
        originalContainer.classList.add('awtomic-ready');
      };
      // Clone themes can reveal immediately — the original gets swapped out.
      // Direct themes stay hidden until processing finishes to avoid flicker.
      if (!isDirectTheme(themeName)) {
        markReady();
      }

      const bundleGroups = groupBundleItems(cartData);
      if (Object.keys(bundleGroups).length === 0) {
        debug('No bundle groups in cart');
        return;
      }
      debug(
        `Found ${Object.keys(bundleGroups).length} bundle group(s):`,
        Object.keys(bundleGroups),
      );

      // If bundle items exist in the cart but none are visible in the DOM,
      // the rollup already happened elsewhere (e.g. server-side rendering).
      const bundleItemKeys = new Set(
        Object.values(bundleGroups).flatMap((g) => g.items.map((i) => i.key)),
      );
      const visibleBundleRows = findAndMatchCartItems(
        cartData,
        originalContainer,
        selectors,
        themeName,
      ).filter(
        (m) =>
          bundleItemKeys.has(m.cartItem.key) &&
          (context.type !== 'page' || m.row.offsetParent !== null),
      );
      if (bundleItemKeys.size > 0 && visibleBundleRows.length === 0) {
        debug(`Rollup already rendered for ${context.type} cart, skipping`);
        rollupAlreadyDone[context.type] = true;
        return;
      }

      // Remove leftovers from a previous pass.
      if (isDirectTheme(themeName)) {
        originalContainer
          .querySelectorAll(themeCfg.cleanupSelector)
          .forEach((el) => el.remove());
      } else {
        itemsContainer
          ?.querySelectorAll('tbody.awtomic-processed')
          .forEach((el) => el.remove());
      }

      const containerToProcess = isDirectTheme(themeName)
        ? originalContainer
        : originalContainer.cloneNode(true);
      if (containerToProcess !== originalContainer) {
        containerToProcess.classList.add('awtomic-processed');
        containerToProcess.classList.remove('awtomic-original');
      }

      const matches = findAndMatchCartItems(
        cartData,
        containerToProcess,
        selectors,
        themeName,
      );
      debug(
        `Matched ${matches.length}/${cartData.items.length} cart items in DOM`,
      );

      await createBundleRows(
        bundleGroups,
        matches,
        themeName,
        selectors,
        cartData,
      );

      if (isDirectTheme(themeName)) {
        markReady();
      } else {
        originalContainer.classList.add('awtomic-original');
        itemsContainer.appendChild(containerToProcess);
        originalContainer.style.display = 'none';
        const parentWrapper = originalContainer.parentElement;
        if (
          parentWrapper &&
          !parentWrapper.querySelector('.awtomic-processed')
        ) {
          parentWrapper.style.display = 'none';
        }
      }

      rollupAlreadyDone[context.type] = true;
      debug(`Rollup completed for ${context.type} cart (${themeName})`);
    } catch (error) {
      console.error(
        `[Awtomic Cart Rollup] Error processing ${context.type} cart:`,
        error,
      );
    } finally {
      isProcessing = false;
    }
  };

  const analyzeCart = async () => {
    if (isProcessing || Date.now() - lastProcessedTime < 1500) {
      return;
    }

    try {
      const newTheme = detectTheme();
      if (newTheme.name !== THEME.name) {
        debug(`Theme changed: ${THEME.name} → ${newTheme.name}`);
        THEME = newTheme;
      }

      const contexts = getCartContexts();
      if (contexts.length === 0) {
        debug('No cart contexts found');
        removeAntiFlicker();
        return;
      }

      const cartData = await fetchCartData();
      if (!cartData) {
        debug('No cart data returned');
        removeAntiFlicker();
        return;
      }

      for (const context of contexts) {
        if (rollupAlreadyDone[context.type]) {
          debug(`Rollup already done for ${context.type} cart, skipping`);
          continue;
        }
        await processCartContext(context, cartData);
      }

      updateCartBubble(cartData);
      removeAntiFlicker();
    } catch (error) {
      console.error('[Awtomic Cart Rollup] Error in analyzeCart:', error);
      removeAntiFlicker();
    }
  };

  // ── Event wiring ───────────────────────────────────────────────────────────

  const setupEventListeners = () => {
    const safeAnalyze = () => {
      try {
        analyzeCart();
      } catch (error) {
        console.error('[Awtomic Cart Rollup] Listener error:', error);
      }
    };

    const createObserver = (callback, options) => {
      const observer = new MutationObserver((...args) => {
        try {
          callback(...args);
        } catch (error) {
          console.error('[Awtomic Cart Rollup] Observer error:', error);
        }
      });
      return {
        observe: (el) => observer.observe(el, options),
        disconnect: () => observer.disconnect(),
      };
    };

    [
      'cart:update',
      'cart:updated',
      'cart:refresh',
      'cart:refreshed',
      'cart-drawer:open',
      'cart-drawer:updated',
      'cart-drawer:refresh',
      'drawer:open',
      'cart:open',
      'theme:cart:open',
      'ajaxCart.afterCartLoad',
      'drawer.didOpen',
    ].forEach((event) => document.addEventListener(event, safeAnalyze));

    document.addEventListener('click', (e) => {
      if (
        e.target.closest(
          '[data-open-drawer], [data-cart-drawer], .cart-icon, [href="#cart-drawer"], .js-drawer-open-right, [data-ajax-cart-toggle-class-button]',
        )
      ) {
        safeAnalyze();
      }
    });

    const observeDrawer = () => {
      if (!THEME.drawer) {
        return;
      }

      observers.drawer?.disconnect();

      let drawerAnalyzeTimer = null;
      let drawerRetryTimer = null;

      const scheduleDrawerAnalyze = () => {
        // Shapes can render the drawer several times during one cart update.
        // Debounce those rapid changes before applying the bundle rollup.
        clearTimeout(drawerAnalyzeTimer);
        clearTimeout(drawerRetryTimer);

        drawerAnalyzeTimer = setTimeout(() => {
          // Reset at execution time so an earlier pass cannot mark the newly
          // rendered drawer as already processed.
          rollupAlreadyDone.drawer = false;
          lastCartData.drawer = null;
          lastProcessedTime = 0;

          safeAnalyze();
        }, 500);

        // Run one unconditional final pass after Shapes' AJAX rendering has
        // completed. This restores the rollup if Shapes replaced it.
        drawerRetryTimer = setTimeout(() => {
          rollupAlreadyDone.drawer = false;
          lastCartData.drawer = null;
          lastProcessedTime = 0;

          safeAnalyze();
        }, 1800);
      };

      const drawer = document.querySelector(THEME.drawer.selectors);

      if (drawer) {
        observers.drawer = createObserver(
          (mutations) => {
            const drawerAttributeChanged = mutations.some(
              (mutation) =>
                mutation.type === 'attributes' &&
                (mutation.attributeName === 'style' ||
                  mutation.attributeName === 'class' ||
                  mutation.attributeName === 'open'),
            );

            const unprocessedCartRowsAdded = mutations.some((mutation) => {
              if (mutation.type !== 'childList') {
                return false;
              }

              return Array.from(mutation.addedNodes).some((node) => {
                if (node.nodeType !== Node.ELEMENT_NODE) {
                  return false;
                }

                const isUnprocessedRow = node.matches?.(
                  'li[data-line-item-key]:not([data-awtomic-bundle])',
                );
                const containsUnprocessedRow = node.querySelector?.(
                  'li[data-line-item-key]:not([data-awtomic-bundle])',
                );

                return isUnprocessedRow || containsUnprocessedRow;
              });
            });

            if (
              (drawerAttributeChanged || unprocessedCartRowsAdded) &&
              THEME.drawer.visibilityCheck(drawer)
            ) {
              debug('Shapes drawer changed, analyzing cart');
              scheduleDrawerAnalyze();
            }
          },
          {
            attributes: true,
            attributeFilter: ['style', 'class', 'open'],
            childList: true,
            subtree: true,
          },
        );

        observers.drawer.observe(drawer);
      } else {
        // The drawer may be injected later. Watch until it exists, then
        // install the full drawer observer.
        const bodyObserver = createObserver(
          (mutations) => {
            const elementAdded = mutations.some((mutation) =>
              Array.from(mutation.addedNodes).some(
                (node) => node.nodeType === Node.ELEMENT_NODE,
              ),
            );

            if (
              elementAdded &&
              !observers.drawer &&
              document.querySelector(THEME.drawer.selectors)
            ) {
              bodyObserver.disconnect();
              observeDrawer();
            }
          },
          {
            childList: true,
            subtree: true,
          },
        );

        bodyObserver.observe(document.body);
      }
    };

    const observeRebuyCart = () => {
      observers.rebuy?.disconnect();
      const rebuyCart = document.querySelector('#rebuy-cart, .rebuy-cart');
      if (!rebuyCart) {
        return;
      }
      debug('Observing Rebuy cart');
      observers.rebuy = createObserver(
        (mutations) => {
          for (const m of mutations) {
            if (
              m.type === 'attributes' &&
              (m.attributeName === 'class' || m.attributeName === 'aria-hidden')
            ) {
              const isOpen =
                m.target.classList.contains('is-visible') ||
                m.target.getAttribute('aria-hidden') === 'false';
              if (isOpen) {
                debug('Rebuy cart opened, analyzing');
                // Vue re-renders fresh DOM on each open; force a re-apply.
                rollupAlreadyDone.rebuy = false;
                lastCartData.rebuy = null;
                safeAnalyze();
              }
              break;
            }
            if (
              m.type === 'childList' &&
              Array.from(m.addedNodes).some((n) => n.nodeType === 1)
            ) {
              debug('Rebuy cart items changed, re-analyzing');
              rollupAlreadyDone.rebuy = false;
              lastCartData.rebuy = null;
              setTimeout(safeAnalyze, 150);
              break;
            }
          }
        },
        {
          attributes: true,
          attributeFilter: ['class', 'aria-hidden'],
          childList: true,
          subtree: true,
        },
      );
      observers.rebuy.observe(rebuyCart);
    };

    const observeCartPage = () => {
      if (window.location.pathname.includes('/cart')) {
        const cartTable =
          document.querySelector('table.cart-items, .cart-items__table') ||
          document.querySelector('form[action*="/cart"] table');
        if (cartTable) {
          createObserver(() => setTimeout(safeAnalyze, 100), {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class'],
          }).observe(cartTable);
        }

        if (THEME.name === 'Supply') {
          const container = document.querySelector('[data-products]');
          if (container) {
            createObserver(() => setTimeout(safeAnalyze, 150), {
              childList: true,
              subtree: true,
              attributes: true,
              attributeFilter: ['class'],
            }).observe(container);
          }
        }
      }

      if (THEME.name === 'Supply') {
        const cartItems = document.querySelector('.cart__items');
        if (cartItems) {
          createObserver(() => setTimeout(safeAnalyze, 150), {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class', 'data-count'],
          }).observe(cartItems);
        }
      }

      const listSelector = { Wonder: 'ul.wt-cart__list', BLS: '.bls-items' }[
        THEME.name
      ];
      if (listSelector) {
        document.querySelectorAll(listSelector).forEach((list) => {
          createObserver(() => setTimeout(safeAnalyze, 150), {
            childList: true,
            subtree: true,
          }).observe(list);
        });
      }
    };

    // Rebuy injects #rebuy-cart after page load; watch for it.
    const observeBody = () => {
      new MutationObserver(() => {
        if (
          !observers.rebuy &&
          document.querySelector('#rebuy-cart, .rebuy-cart')
        ) {
          observeRebuyCart();
        }
      }).observe(document.body, { childList: true, subtree: true });
    };

    onDocReady(() => {
      observeDrawer();
      observeRebuyCart();
      observeCartPage();
      observeBody();
    });
  };

  // ── Init ───────────────────────────────────────────────────────────────────

  const init = async () => {
    try {
      // Warm the product cache for bundles already in the cart.
      const cartData = await fetchCartData();
      if (cartData) {
        await Promise.all(
          Object.values(groupBundleItems(cartData))
            .filter(
              (g) => g.properties._bundleHandle && g.properties._variantId,
            )
            .map((g) =>
              fetchBundleProductData(
                g.properties._bundleHandle,
                g.properties._variantId,
              ),
            ),
        );
      }

      setupEventListeners();

      onDocReady(() => {
        analyzeCart();
        // Fix the bubble count on pages without a cart context too.
        fetchCartData().then((data) => data && updateCartBubble(data));
      });

      window.awtomicCartRollup = {
        analyze: analyzeCart,
        version: '1.1.0',
        config,
        get theme() {
          return THEME;
        },
      };
    } catch (error) {
      console.error('[Awtomic Cart Rollup] Initialization error:', error);
      removeAntiFlicker();
    }
  };

  init();
})();
